export default function(){
	const tabsContainer = document.querySelectorAll('[data-name="tabs-container"]');

	if (tabsContainer.length === 0) return;

	tabsContainer.forEach(container => {
		const tabList = container.querySelector('[role="tablist"]');
		const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
		const tabPanels = Array.from(container.querySelectorAll('.tab-panel'));
		const tabsSelect = container.querySelector('[data-name="tabs-select"]');

		let focusedTab = 0;
		let currentActiveTab = 0;

		// Initialize opacity and Events Calendar for the first visible tab on page load
		setTimeout(() => {
			// Set all panels to opacity 0 initially
			tabPanels.forEach(panel => {
				panel.style.opacity = '0';
				panel.style.transition = 'opacity 0.5s ease-in-out';
			});
			
			// Find and fade in the first visible panel
			const firstPanel = tabPanels.find(panel => panel.style.display !== 'none');
			if (firstPanel) {
				// Fade in the first panel after 0.5s delay
				setTimeout(() => {
					firstPanel.style.opacity = '1';
				}, 500);
				
				// Initialize Events Calendar
				setTimeout(() => {
					initializeEventsCalendar(firstPanel);
				}, 600);
			}
		}, 100);

		tabList.addEventListener("keydown", handleTabListKeydown);

		for (const tab of tabs) {
			tab.addEventListener("click", handleTabClick);
		}

		// Add event listener for select element if it exists
		if (tabsSelect) {
			tabsSelect.addEventListener('change', handleTabSelect);
		}

		function updateTabFocus() {
			for (const tab of tabs) {
				tab.setAttribute("tabindex", -1);
			}
			tabs[focusedTab].setAttribute("tabindex", 0);
			tabs[focusedTab].focus();
		}

		function handleTabListKeydown(event) {
			const key = event.key;

			if (key === "ArrowRight" || key === "ArrowLeft") {
				if (key === "ArrowRight") {
					focusedTab++;
					if (focusedTab >= tabs.length) {
						focusedTab = 0;
					}
				} else if (key === "ArrowLeft") {
					focusedTab--;
					if (focusedTab < 0) {
						focusedTab = tabs.length - 1;
					}
				}
				updateTabFocus();
			}
		}

		function handleTabClick(event) {
			const target = event.target;
			const selectedTabIndex = tabs.indexOf(target);

			if (selectedTabIndex === currentActiveTab) {
				return;
			}

			// Update tab states
			for (const tab of tabs) {
				tab.setAttribute("aria-selected", false);
			}
			target.setAttribute("aria-selected", true);

			// Update select dropdown
			if (tabsSelect) {
				tabsSelect.selectedIndex = selectedTabIndex;
			}

			focusedTab = selectedTabIndex;
			updateTabFocus();

			// Switch tab content
			switchTabContent(selectedTabIndex);
		}

		function handleTabSelect(event) {
			const target = event.target;
			const selectedPanelId = target.value;
			
			// Find the tab that controls this panel
			const tabToClick = tabs.find(tab => tab.getAttribute('aria-controls') === selectedPanelId);
			
			if (tabToClick) {
				tabToClick.click();
			}
		}

		function switchTabContent(tabIndex) {
			// Set all panels to opacity 0 and hide them
			tabPanels.forEach(panel => {
				panel.style.opacity = '0';
				panel.style.display = 'none';
			});

			// Show the selected panel
			if (tabPanels[tabIndex]) {
				tabPanels[tabIndex].style.display = 'block';
				tabPanels[tabIndex].style.transition = 'opacity 0.5s ease-in-out';
				
				// Fade in the selected panel after 0.5s delay
				setTimeout(() => {
					tabPanels[tabIndex].style.opacity = '1';
				}, 1000);
				
				// Force Events Calendar to reinitialize if present
				setTimeout(() => {
					initializeEventsCalendar(tabPanels[tabIndex]);
				}, 600);
			}

			currentActiveTab = tabIndex;
		}
		
		function initializeEventsCalendar(panel) {
			// Check if this panel contains Events Calendar
			const tribeElements = panel.querySelectorAll('.tribe-events, [data-js*="tribe"], .tribe-common');
			
			if (tribeElements.length > 0) {
				console.log('Initializing Events Calendar in tab panel...');
				
				// Look for week view button and click it
				const weekViewButton = panel.querySelector('a[data-js="tribe-events-view-link"][href*="/week/"]');
				
				if (weekViewButton) {
					console.log('Found week view button, clicking it...');
					// Small delay to ensure the panel is fully visible
					setTimeout(() => {
						weekViewButton.click();
						console.log('Week view button clicked successfully');
					}, 100);
				} else {
					console.log('No week view button found, trying alternative approach...');
					
					// Alternative: look for any view selector button and click week if available
					const viewSelectorButtons = panel.querySelectorAll('a[data-js="tribe-events-view-link"]');
					const weekButton = Array.from(viewSelectorButtons).find(btn => 
						btn.textContent.toLowerCase().includes('week') || 
						btn.href.includes('/week/')
					);
					
					if (weekButton) {
						console.log('Found week button in view selector, clicking it...');
						setTimeout(() => {
							weekButton.click();
							console.log('Week button clicked successfully');
						}, 100);
					} else {
						console.log('No week view button found in this panel');
					}
				}
			}
		}
	});

	// Handle URL tab parameter
	const urlParams = new URLSearchParams(window.location.search);
	const tabParam = urlParams.get('tab');
	
	if (tabParam) {
		const tab = document.querySelector(`[data-name="${tabParam}"]`);

		if (tab) {
			setTimeout(() => {
				const block = tab.closest('.block');
				if (block) {
					const headerOffset = 50;
					const elementPosition = block.getBoundingClientRect().top;
					const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
			}, 100);

			tab.click();
		}
	}
}